import { AccountsService } from '@packages/contexts/accounts';
import { AnalyticsService } from '@packages/core/analytics';
import { AuthService, AuthTokenService } from '@packages/contexts/auth';
import { BmisService } from '@packages/contexts/bmis';
import { CidCvnService } from '@packages/contexts/cid-cvn';
import { CommentsService } from '@packages/contexts/comments';
import { ConfigService } from '@packages/core/config';
import { ContentSettingsService } from '@packages/contexts/content-settings';
import { CvtService } from '@packages/contexts/cvt';
import { DashboardService } from '@packages/contexts/dashboard/dashboard.service';
import { DmsService } from '@packages/contexts/dms';
import { EntitiesService } from '@packages/contexts/entities';
import { EscalationService } from '@packages/contexts/escalations';
import { EvBatteryService } from '@packages/contexts/ev-battery-service/evbattery.service';
import { FailCodesService } from '@packages/contexts/qmrs';
import { FeedbackService, FeedbackAdminService } from '@packages/contexts/feedback';
import { HttpClient } from '@packages/core/http';
import { InvestigationService } from '@packages/contexts/investigations';
import { LocationsService } from '@packages/contexts/locations';
import { NotificationsService } from '@packages/contexts/notifications';
import {
    PendingReviewQmrsService,
    QmrsDashboardDistrictStatsService,
    QmrsDashboardService,
} from '@packages/contexts/qmrsdashboard';
import { PermissionsService } from '@packages/contexts/permissions';
import { QmrsService } from '@packages/contexts/qmrs';
import { StorageService } from '@packages/core/storage';
import { SynonymsService } from '@packages/contexts/synonyms';
import { TechlineService } from '@packages/contexts/techline/techline.service';
import { ToughbookAttachmentsService } from '@packages/contexts/toughbook-attachments';
import { WorksheetsService } from '@packages/contexts/worksheets';
import { AssetUploadsService } from './asset-uploads.service';
import { DocsService } from '@web/vin-sessions/context/docs-session.service';
import { GoogleAnalyticsService } from '@web/core/google-analytics/google-analytics.service';
import { OtpwService } from './otpw.service';
import { PushNotificationsService } from './push-notifications.service';
import { VinSessionService } from '@web/vin-sessions/context/vin-session.service';
import { container } from './container';

export const accountsService = container.resolve(AccountsService);
export const analyticsService = container.resolve(AnalyticsService);
export const assetUploadsService = container.resolve(AssetUploadsService);
export const authService = container.resolve(AuthService);
export const authTokenService = container.resolve(AuthTokenService);
export const bmisService = container.resolve(BmisService);
export const cidCvnService = container.resolve(CidCvnService);
export const commentsService = container.resolve(CommentsService);
export const configService = container.resolve(ConfigService);
export const contentSettingsService = container.resolve(ContentSettingsService);
export const cvtService = container.resolve(CvtService);
export const dashboardService = container.resolve(DashboardService);
export const dmsService = container.resolve(DmsService);
export const docsService = container.resolve(DocsService);
export const entitiesService = container.resolve(EntitiesService);
export const escalationsService = container.resolve(EscalationService);
export const evBatteryService = container.resolve(EvBatteryService);
export const failCodesService = container.resolve(FailCodesService);
export const feedbackAdminService = container.resolve(FeedbackAdminService);
export const feedbackService = container.resolve(FeedbackService);
export const googleAnalyticsService = container.resolve(GoogleAnalyticsService);
export const httpClient = container.resolve(HttpClient);
export const investigationService = container.resolve(InvestigationService);
export const locationsService = container.resolve(LocationsService);
export const notificationsService = container.resolve(NotificationsService);
export const otpwService = container.resolve(OtpwService);
export const pendingReviewQmrsService = container.resolve(PendingReviewQmrsService);
export const permissionsService = container.resolve(PermissionsService);
export const pushNotificationsService = container.resolve(PushNotificationsService);
export const qmrsDashboardDistrictStatsService = container.resolve(QmrsDashboardDistrictStatsService);
export const qmrsDashboardService = container.resolve(QmrsDashboardService);
export const qmrsService = container.resolve(QmrsService);
export const storageService = container.resolve(StorageService);
export const synonymsService = container.resolve(SynonymsService);
export const techlineService = container.resolve(TechlineService);
export const toughbookAttachmentsService = container.resolve(ToughbookAttachmentsService);
export const vinSessionService = container.resolve(VinSessionService);
export const worksheetsService = container.resolve(WorksheetsService);
